// extracted by mini-css-extract-plugin
export default {"section":"ExpandableSection_section__ZkdPI","header":"ExpandableSection_header__iPlAd","expandableContent":"ExpandableSection_expandableContent__r8tj1"};